import type {
    AiDocumentSourceParams,
    AiDocumentSourceStats,
    AiStatsParams,
    AiUsageStats,
    AiUserUsageDetail,
} from '@/types';
import type { AxiosInstance, AxiosResponse } from 'axios';

class AiStatsService {
    private readonly apiService;

    constructor(apiService: AxiosInstance) {
        this.apiService = apiService;
    }

    /** Haalt de AI usage-statistieken op (admin-only, geproxyd naar de gateway). */
    index(params: AiStatsParams = {}): Promise<AxiosResponse<AiUsageStats>> {
        return this.apiService.get('/api/admin/ai/stats', { params });
    }

    /** Per-user drill-down (admin-only, MILO-261); geaggregeerd, zonder gespreksinhoud. */
    userDetail(userId: string, params: AiStatsParams = {}): Promise<AxiosResponse<AiUserUsageDetail>> {
        return this.apiService.get(`/api/admin/ai/users/${encodeURIComponent(userId)}/usage`, { params });
    }

    /**
     * Documenten per herkomstkanaal (admin-only, MILO-364).
     *
     * Komt uit milo-api zelf in plaats van uit de gateway-telemetrie, en gaat
     * daarom terug tot de lancering in plaats van 30 dagen. Zonder date_from/
     * date_to is het venster onbegrensd.
     */
    documentsBySource(params: AiDocumentSourceParams = {}): Promise<AxiosResponse<{ data: AiDocumentSourceStats }>> {
        return this.apiService.get('/api/admin/documents/by-source', { params });
    }
}

export default AiStatsService;
